import type React from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

interface LoginDialogContextValue {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

const LoginDialogContext = createContext<LoginDialogContextValue | null>(null);

export const LoginDialogProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => {
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <LoginDialogContext.Provider value={{ open, openDialog, closeDialog }}>
      {children}
    </LoginDialogContext.Provider>
  );
};

export const useLoginDialog = () => {
  const context = useContext(LoginDialogContext);
  if (!context) {
    throw new Error('useLoginDialog must be used within LoginDialogProvider');
  }
  return context;
};
